export default __webpack_public_path__ + "static/media/CSS_logo.6854789a.svg";